import React, { useState, useEffect } from "react";

const Marquee = () => {
  const [isPaused, setIsPaused] = useState(false);
  const [animationSpeed, setAnimationSpeed] = useState(30);

  const marqueeText =
    "BOOK WITH US NOW | ONE STOP FOR LUXURY MAKEUP | AWM MAKEOVERS | PROFESSIONAL BRIDAL STYLING | LUXURY BEAUTY SERVICES";

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 640) {
        setAnimationSpeed(20);
      } else if (width < 1024) {
        setAnimationSpeed(25);
      } else {
        setAnimationSpeed(30);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  
  return (
    <div className="w-full bg-black text-white overflow-hidden relative marquee-container">
      <div className="absolute left-0 top-0 w-8 md:w-16 h-full bg-gradient-to-r from-black to-transparent z-10"></div>
      <div className="absolute right-0 top-0 w-8 md:w-16 h-full bg-gradient-to-l from-black to-transparent z-10"></div>

      <div
        className="flex whitespace-nowrap py-2 md:py-3 marquee-animation"
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
        style={
          {
            "--animation-duration": `${animationSpeed}s`,
            "--animation-play-state": isPaused ? "paused" : "running",
          } as React.CSSProperties
        }
      >
        {[...Array(6)].map((_, index) => (
          <span
            key={index}
            className="inline-block px-4 text-xs sm:text-sm md:text-base font-light tracking-wide font-body"
            style={{ minWidth: "max-content" }}
          >
            {marqueeText}
          </span>
        ))}
      </div>

      <style>
        {`
          @keyframes marquee-scroll {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-25%);
            }
          }
          
          .marquee-animation {
            animation: marquee-scroll var(--animation-duration) linear infinite;
            animation-play-state: var(--animation-play-state);
          }
          
          /* Pause animation on reduced motion preference */
          @media (prefers-reduced-motion: reduce) {
            .marquee-animation {
              animation-duration: 0.01ms !important;
              animation-iteration-count: 1 !important;
              opacity: 1;
            }
          }

          /* High contrast mode support */
          @media (prefers-contrast: high) {
            .marquee-container {
              background-color: #000000 !important;
              border: 1px solid #ffffff;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Marquee;
